import {
  useTranslation as useTranslationReacti18next
} from "react-i18next";

export default function useTranslation() {
  const { t, i18n } = useTranslationReacti18next();

  return { t, i18n };
}
